import React from 'react';
import './About.css';

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <p className="section-label">About</p>
        <h2 className="section-title">About Me</h2>
        <div className="about-body">
          <p>
            I'm a first-year Honours Mathematics student at the University of Waterloo
            (Data Science focus) with experience in full-stack development, computer
            vision, and NLP. I enjoy designing end-to-end AI systems that combine data
            pipelines, machine learning, and user-facing applications to solve
            real-world problems.
          </p>
          <p>
            My work spans computer vision, financial data analysis, and scalable web
            systems, with an emphasis on impactful, production-ready solutions.
          </p>
        </div>
      </div>
    </section>
  );
}
